<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="配置项名称" prop="name" required>
        <el-input v-model="form.name" placeholder="请输入配置项名称" v-trim/>
      </el-form-item>
      <el-form-item label="键" prop="key" required>
        <el-input v-model="form.key" placeholder="请输入键" v-trim/>
      </el-form-item>
      <el-form-item label="值" prop="value" required>
        <el-input type="textarea" :rows="5" v-model="form.value" placeholder="请输入值" v-trim/>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" :rows="5" v-model="form.remark" placeholder="请输入备注" v-trim/>
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/common/GlobalWindow'
import BaseOpera from '@/components/base/BaseOpera'
export default {
  name: 'ConfigDrawer',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      form: {
        id: null,
        name: '',
        key: '',
        value: '',
        remark: ''
      },
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入配置项名称' }
        ],
        key: [
          { required: true, message: '请输入键' }
        ],
        value: [
          { required: true, message: '请输入值' }
        ]
      }
    }
  },
  created () {
    this.config({
      api: '/system/config'
    })
  }
}
</script>

<style scoped lang="scss">

</style>
